export default __webpack_public_path__ + "static/media/5.29b0f336.jpg";